import { go } from '@/libs/router'
import { mgop } from '@aligov/jssdk-mgop'
import axios from 'axios'
import { WECHAT_APPID, WECHAT_SERVER, APP_SERVER } from '@/consts/const'
// /**
//  * 判断是否是iOS设备
//  * @returns {boolean}
//  */
//  export function isIOS() {
//   return /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(window.navigator.userAgent)
// }

// /**
//  * 判断是否是Android
//  * @returns {boolean}
//  */
// export function isAndroid() {
//   return /Android/i.test(navigator.userAgent)
// }
/**
 * 为 url 添加/设置参数
 * name：
 * value：
 */
 export function fnDwHz (address, areaCode) {
  return new Promise((resolve, reject) => {
  var key = '3c5450dbf0ec2b580a99399ca32e36de'

  // if (v_lng && v_lat) {
      // if(v_key){
      //     key=v_key;
      // }
    //  var locationLngLat = v_lng + ',' + v_lat 330100
      var gdUrl = 'https://restapi.amap.com/v3/geocode/geo?key={{@key}}&address={{@address}}&city=' + areaCode
      gdUrl = gdUrl.replace('{{@key}}', key).replace('{{@address}}', address)
      axios.get(gdUrl).then(res => {
        // console.log(res, '0000')
        var retJson = res.data
        if (retJson.status === '1') {
            // address = retJson.regeocode.formatted_address || ''
            // let xzqh = retJson.regeocode.addressComponent.adcode || ''
            // let xzqhMc = retJson.regeocode.addressComponent.district || ''
            console.log(retJson)
           resolve({data: true})
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
           reject({data: false})
        }
      })
//  }
})
}
/**
 * 为 url 添加/设置参数
 * name：
 * value：
 */
 export function fnDwHzTd (address, areaCode) {
  return new Promise((resolve, reject) => {
    var gdUrl = `https://api.tianditu.gov.cn/v2/search?postStr={"keyWord":"${address}","queryType":12,"start":0,"count":10,"specify":"156${areaCode.substring(0, 6)}"}&type=query&tk=9bca3b1e09505c6c5a56a100c9ff1b4b`
    axios.get(gdUrl).then(res => {
      console.log(res, 'fnDwHzTd--------')
      var retJson = res.data
      if (retJson.count > 0) {
        console.log(retJson)
        resolve({data: true})
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({data: false})
      }
    }).catch(err => {
      console.log(err, 'err--------=====--------')
      // eslint-disable-next-line prefer-promise-reject-errors
      reject({data: false})
    })
  })
}
function urlParam (url, name, value) {
  if (url.indexOf('?') > 0) {
    let qs = url.substring(url.indexOf('?'))
    if (qs.indexOf(name + '=') > 0) {
      let i0 = qs.indexOf(name + '=') + (name + '=').length
      let i1 = qs.indexOf('&', i0)
      if (i1 < 0) {
        qs = qs.substring(0, i0) + value
      } else {
        qs = qs.substring(0, i0) + value + qs.substring(i1)
      }
      return url.substring(0, url.indexOf('?')) + qs
    }
    return url + '&' + name + '=' + value
  } else {
    return url + '?' + name + '=' + value
  }
}

/**
 * 为 url 添加/设置参数
 * paramObj: 参数对象
 */
export function urlParamObj (url, paramObj) {
  for (let name in paramObj) {
    url = urlParam(url, name, encodeURIComponent(paramObj[name]) || '')
  }
  return url
}

/**
 * 将URL分解为参数
 * @param url  需分解的URL
 * @return {baseUrl,anchor,params:{param1:value1,param2:value2,param3:value3,...}}
 */
export function parseUrl (url) {
  if (!url) return {}
  // 获取 query-string
  let idx = url.indexOf('?')
  if (idx < 0) return { 'baseUrl': url, 'anchor': '', 'params': {} }
  let ret = {
    'baseUrl': url.substring(0, idx),
    'anchor': '',
    'params': {}
  }
  let qs = url.substring(idx + 1)
  // 页内锚链接
  idx = qs.indexOf('#')
  if (idx >= 0) {
    ret.anchor = qs.substring(idx + 1)
    qs = qs.substring(0, idx)
  }
  //
  let paramArr = qs.split('&')
  for (let i = 0; i < paramArr.length; i++) {
    let pair = paramArr[i].split('=')
    let name = pair[0]
    let value = pair.length > 1 ? pair[1] : ''
    if (ret.params.hasOwnProperty(name)) {
      let oldValue = ret.params[name]
      if (oldValue instanceof Array) {
        oldValue.push(value)
      } else {
        ret.params[name] = [oldValue, value]
      }
    } else {
      ret.params[name] = value
    }
  }
  return ret
}
/**
 *
 * @param url  需分解的URL
 * @return {baseUrl,anchor,params:{param1:value1,param2:value2,param3:value3,...}}
 */
export function getLocationHref () {
  return parseUrl(window.location.href)
}

/**
 * 微信用户授权2.0
 * @param ops: {
 *         appid: 'wx6408b0c792dd4929', // 必填
 *        redirect_uri: 'http://zw9r4f.natappfree.cc/#/next',
 *        response_type: 'code',
 *        scope: 'snsapi_userinfo'
 *      }
 */
export function wechatAuth_2_0 (ops) {
  // const basePath = 'https://open.weixin.qq.com/connect/oauth2/authorize'
  // const param = {
  //   appid: 'wx6408b0c792dd4929',
  //   redirect_uri: 'http://zw9r4f.natappfree.cc/#/next',
  //   response_type: 'code',
  //   scope: 'snsapi_userinfo'
  // }
  const param = {
    appid: WECHAT_APPID,
    redirect_uri: ops.redirect_uri || APP_SERVER,
    response_type: ops.response_type || 'code',
    scope: ops.scope || 'snsapi_userinfo'
  }
  const paramStr = urlParamObj(WECHAT_SERVER, param)
  const url = paramStr + '#wechat_redirect'
  go(url)
}

/**
 * 获取token
 * @param ops
 * @returns {*}
 */
export function getWechattokenInHref (ops) {
  return getLocationHref().params['token'] || ''
}
/**
 * 获取dealKey
 * @param ops
 * @returns {*}
 */
export function getDealKeyInHref () {
  return getLocationHref().params['dealKey'] || ''
}
/**
 * 判断是否是微信
 * @returns {boolean}
 */
export function isWeChat () {
  let ua = '' + window.navigator.userAgent.toLowerCase()
  let weChat = /MicroMessenger/i.test(ua)
  return weChat
}

/**
 * 判断是否是mac os
 * @returns {boolean}
 */
export function isIOS () {
  let ua = '' + window.navigator.userAgent.toLowerCase()
  let iOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua)
  return iOS
}

/**
 * 判断是否是Android
 * @returns {boolean}
 */
export function isAndroid () {
  let ua = '' + window.navigator.userAgent.toLowerCase()
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  return isAndroid
}

/**
 * 判断是否是iOS微信
 * @returns {boolean}
 */
export function isIOSWechat () {
  return isWeChat() && isIOS()
}

/**
 * 修复iOS12在微信端页面键盘回收后，不自动回弹bug
 */
export function fixKeyboardPage () {
  if (!isIOSWechat()) return
  let scrollTop
  document.body.addEventListener('focusin', () => {
    clearTimeout(scrollTop)
  })
  document.body.addEventListener('focusout', () => {
    clearTimeout(scrollTop)
    scrollTop = setTimeout(function () {
      window.scrollTo(0, 0)
    }, 200)
  })
}

/**
 * 深拷贝对象
 * @param obj
 * @returns {any}
 */
export function deepCopy (obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 微信对象
 * @type {null}
 */
let g_wechat = null

/**
 * 存储微信对象
 * @param wechat
 */
export function initWechat (wechat) {
  g_wechat = wechat
}

/**
 * 获取微信对象
 * @param wechat
 * @returns {null}
 */
export function getWechat (wechat) {
  return g_wechat
}
/**
 * @param {string} base64转file
 * @returns {Object}
 */
 export function base64ToFile (urlData, fileName) {
  const arr = urlData.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bytes = atob(arr[1]) // 解码base64
  let n = bytes.length
  const ia = new Uint8Array(n)
  while (n--) {
    ia[n] = bytes.charCodeAt(n)
  }
  return new File([ia], fileName, { type: mime })
}

export function getToken () {
  mgop({
    api: 'mgop.trustway.wfjb.auth', // 必须
    host: 'https://bus-jcss.police.hangzhou.gov.cn/openapi',
    dataType: 'JSON',
    type: 'GET',
    data: {
      platformId: 8
    },
    appKey: 'sjwy7hsc+2001300008+dycyyb',
    onSuccess: (data) => {
      console.log(data, '000000')
      // Indicator.close();
      if (data.data.code == 200) {
        if (data.data.data.isReal !== '1') {
          Toast.show({
            message: '您还未实名，请先实名'
            // type: 'warn'
          })
        }
      localStorage.setItem('token', data.data.data.token)
        // localStorage.setItem('token_time', (new Date()).getTime())
      // localStorage.setItem('token_url', data.data)
        // window.location.href = data.data
      } else {
        Toast.show({
          message: '获取用户token失败！'
          // type: 'warn'
        })
        // ({
        //   text: data.msg,
        //   type: 'warn'
        // })
      }

      /* // console.log('data', data)
                     localStorage.setItem('sfzmhm',data.data)
                     // setToken('X-TOKEN',data.data)
                     that.getServerToken(data.data)

                     //机动车
                     // router.push('/certificate/CarList')
                     //驾驶证
                     router.push('/certificate/DrvCard') */
    },
    onFail: (err) => {
      console.log(err, 'err--------=====--------')
    }
  })
}

/**
 * 判断是否是浙里办app
 * @returns {boolean}
 */
export function isZLB () {
  // if (process.env.BUILD_ENV === 'zlb') {
  //   return true
  // }
  return /dtdream/i.test(window.navigator.userAgent)
}
/**
 * 判断是否是支付宝
 * @returns {boolean}
 */
export function isAlipay () {
  return /AlipayClient/i.test(window.navigator.userAgent)
}

/**
 * 判断是否是支付宝-小程序
 * @returns {boolean}
 */
export function isAlipayMiniProgram () {
  return (
    /AlipayClient/i.test(window.navigator.userAgent) &&
    /MiniProgram/i.test(window.navigator.userAgent)
  )
}
/**
 * 判断是否是警察叔叔
 * @returns {boolean}
 */
export function isJCSS () {
  return /JCSS/i.test(window.navigator.userAgent)
}



// WEBPACK FOOTER //
// ./src/utils/utils.js